import { c as _c } from "react/compiler-runtime";
import { Avatar, HStack, Stack, Text, VStack } from '@chakra-ui/react';
interface CustomerSuccessCardProps {
  quote?: string;
  personFullName?: string;
  personFirstName?: string;
  personLastName?: string;
  personTitle?: string;
  personAvatarUrl?: string;
  companyName?: string;
  bgColor?: string;
  bgGradient?: string;
  color?: string;
}
const CustomerSuccessCard: React.FC<CustomerSuccessCardProps> = t0 => {
  const $ = _c(16);
  const {
    personFullName,
    personAvatarUrl,
    quote,
    bgColor,
    bgGradient
  } = t0;
  let t1;
  if ($[0] !== quote) {
    t1 = <VStack align="flex-start" gap={4}><Text color="textPrimaryAlpha.800" fontSize="md">{quote}</Text></VStack>;
    $[0] = quote;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== personAvatarUrl) {
    t2 = personAvatarUrl ? <Avatar.Root bgColor="primary" size="xs"><Avatar.Fallback /><Avatar.Image src={personAvatarUrl} /></Avatar.Root> : undefined;
    $[2] = personAvatarUrl;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== personFullName) {
    t3 = <Text textStyle="labelSm">{personFullName}</Text>;
    $[4] = personFullName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <HStack>{t2}{t3}</HStack>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <VStack align="flex-start" gap={8} padding={8}>{t1}{t4}</VStack>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== bgColor || $[13] !== bgGradient || $[14] !== t5) {
    t6 = <Stack align="flex-start" bg={bgGradient} bgColor={bgColor} borderRadius="2xl" boxShadow="sm" overflow="hidden" width="full">{t5}</Stack>;
    $[12] = bgColor;
    $[13] = bgGradient;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export default CustomerSuccessCard;